import { MilanBackgroundColors, MilanGradientColors } from "@milanlaser/mlcomponents";
import { backgroundColorOptions, backgroundGradientOptions, altBackgroundColorOptions } from "./builderColorOptions";

import { paddingOptions } from "./builderPaddingOptions";

export const getPaddingInputs = (defaults = {
  desktopTop: "large",
  desktopBottom: "large",
  mobileTop: "small",
  mobileBottom: "small"
}) => {
  const { desktopTop, desktopBottom, mobileTop, mobileBottom } = defaults;
  return [
    {
      name: "desktopPaddingTop",
      type: "string",
      defaultValue: desktopTop,
      friendlyName: "Desktop Padding: Top",
      enum: paddingOptions,
      helperText: "Padding sizes for all options: None (0px), Small (48px), Medium (80px), Large (96px), XLarge (144px)",
      required: false,
    },
    {
      name: "desktopPaddingBottom",
      type: "string",
      defaultValue: desktopBottom,
      friendlyName: "Desktop Padding: Bottom",
      enum: paddingOptions,
      helperText: "See padding sizes above",
      required: false,
    },
    {
      name: "mobilePaddingTop",
      type: "string",
      defaultValue: mobileTop,
      friendlyName: "Tablet/Mobile Padding: Top",
      enum: paddingOptions,
      helperText: "See padding sizes above",
      required: false,
    },
    {
      name: "mobilePaddingBottom",
      type: "string",
      defaultValue: mobileBottom,
      friendlyName: "Tablet/Mobile Padding: Bottom",
      enum: paddingOptions,
      helperText: "See padding sizes above",
      required: false,
    }
  ];
};


type backgroundColorListType = typeof backgroundColorOptions | typeof altBackgroundColorOptions;



export const getBackgroundColorInput = ({
  backgroundColorName,
  defaultValue,
  helperText,
  backgroundColorsList
}: {
  backgroundColorName?: string;
  defaultValue?: MilanBackgroundColors | 'None';
  helperText?: string;
  backgroundColorsList?: backgroundColorListType;
}) => {

  return [
    {
      name: backgroundColorName || "backgroundColor",
      type: "string",
      defaultValue: defaultValue || "None",
      friendlyName: "Background Color",
      enum: backgroundColorsList || backgroundColorOptions,
      helperText: helperText || "Select None if a background gradient is selected.",
      required: false,
    }
  ];
};

export const getBackgroundGradientInput = ({
  backgroundGradientName,
  defaultValue,
  helperText,
  backgroundGradientList
}: {
  backgroundGradientName?: string;
  defaultValue?: MilanGradientColors;
  helperText?: string;
  backgroundGradientList?: typeof backgroundGradientOptions;
}) => {
  return [
    {
      name: backgroundGradientName || "backgroundGradient",
      type: "string",
      defaultValue: defaultValue || "None",
      friendlyName: "Background Gradient",
      enum: backgroundGradientList,
      helperText: helperText || "Select None if a background color is selected.",
      required: false,
    },

  ];
}

export const getWaveGradientInput = ({
  waveGradientName,
  defaultValue,
  helperText,
  waveGradientList
}: {
  waveGradientName?: string;
  defaultValue?: MilanGradientColors;
  helperText?: string;
  waveGradientList?: typeof backgroundGradientOptions;
}) => {
  return [
    {
      name: waveGradientName || "waveGradient",
      type: "string",
      defaultValue: defaultValue || "None",
      friendlyName: "Wave Gradient",
      enum: waveGradientList,
      helperText: helperText || "Select None if a wave color is selected.",
      required: false,
    },

  ];
}